var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main_wrapper"},[_c('div',{staticClass:"title_wrapper"},[_c('span',{staticClass:"title_item"},[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"btn_wrapper",on:{"click":_vm.back}},[_c('svg-icon',{staticStyle:{"width":"22pt","height":"22pt"},attrs:{"icon-class":"fanhui"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }